module.exports = __webpack_public_path__ + "img/B9.a867cf1c.png";